import { CapaQuotationChatMessageType } from '@generated/graphql';
import {
  PurchaseOrderRequestBubble,
  PurchaseOrderPaymentFailedBubble,
  SubmallNotFoundBubble
} from '../PaymentBubbles/Step0Bubbles';
import {
  CompletePaymentBubble,
  WaitForaccountTransferDepositBubble,
  RefusePurchaseOrderBubble,
  RequestToCancelPaymentBubble,
  CompleteCancelPaymentBubble
} from '../PaymentBubbles/Step1Bubbles';
import {
  CompleteRefundBubble,
  RequestToRefundBubble,
  StartManufacturingBubble
} from '../PaymentBubbles/Step2Bubbles';
import {
  InduceManufacturingCompletionBubble,
  RequestRenewalBubble,
  ShippingStartBubble
} from '../PaymentBubbles/Step3Bubbles';
import { TransactionCompletedBubble } from '../PaymentBubbles/Step4Bubbles';
import { PaymentBubbleCommonProps } from '../PaymentBubbles/types';

const paymentBubbles: Partial<Record<
  CapaQuotationChatMessageType,
  React.FunctionComponent<PaymentBubbleCommonProps>
>> = {
  [CapaQuotationChatMessageType.PurchaseOrderRegisterRequest]: PurchaseOrderRequestBubble,
  [CapaQuotationChatMessageType.AwaitingPayment]: WaitForaccountTransferDepositBubble,
  [CapaQuotationChatMessageType.ApprovedPayment]: CompletePaymentBubble,
  [CapaQuotationChatMessageType.FailedPayment]: PurchaseOrderPaymentFailedBubble,
  [CapaQuotationChatMessageType.CancelRequested]: RequestToCancelPaymentBubble,
  [CapaQuotationChatMessageType.CancelConfirmed]: CompleteCancelPaymentBubble,
  [CapaQuotationChatMessageType.RejectedPurchaseOrder]: RefusePurchaseOrderBubble,
  [CapaQuotationChatMessageType.RefundRequested]: RequestToRefundBubble,
  [CapaQuotationChatMessageType.RefundConfirmed]: CompleteRefundBubble,
  [CapaQuotationChatMessageType.StartProcessing]: StartManufacturingBubble,
  [CapaQuotationChatMessageType.StartShipping]: ShippingStartBubble,
  [CapaQuotationChatMessageType.InduceConfirmPurchase]: InduceManufacturingCompletionBubble,
  [CapaQuotationChatMessageType.DelayedConfirmPurchase]: RequestRenewalBubble,
  [CapaQuotationChatMessageType.PurchaseConfirmed]: TransactionCompletedBubble,
  [CapaQuotationChatMessageType.SubmallRegistrationRequest]: SubmallNotFoundBubble
};

export default paymentBubbles;
